import React from 'react';
import formatCurrency from '@/utils/formatCurrency';
import { TBenefit } from '../types';

export const BENEFITS: TBenefit[] = [
  {
    id: 'discount',
    name: '40 000 бонусных баллов',
    getBenefitText: ({ data: { price } }) => {
      if (!price) return '';
      return (
        <>
          Максимальная цена перепродажи на автомобиль OMODA C5 2023 года
          выпуска&nbsp;-&nbsp;
          <nobr>
            {formatCurrency(price, {
              style: 'currency',
            })}
          </nobr>
          , без учета дополнительного оборудования или иных услуг.
        </>
      );
    },
  },
  {
    id: 'gift',
    name: 'O-Privilege',
    getBenefitText: ({ data: { price } }) => {
      if (!price) return '';
      return (
        <>
          Максимальная цена перепродажи на автомобиль OMODA C5 2023 года
          выпуска&nbsp;-&nbsp;
          <nobr>
            {formatCurrency(price, {
              style: 'currency',
            })}
          </nobr>
          , без учета дополнительного оборудования или иных услуг, с учетом пакета
          O-Privilege.
        </>
      );
    },
  },
];
